import axios from 'axios';

export async function getSwimmersDiary(phone: string, name: string, user_id: string) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_SWIMMERS_DIARY}`, {
      params: {
        phone: phone,
        name: name,
        user_id: user_id,
      },
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}
